<style lang="sass">
  .uk-accordion-title
    background-color: #AED47B !important
    color: #ffffff !important
</style>


<template>
  <div class="uk-container uk-container-center uk-margin-top uk-margin-large-bottom main-container">
<ul class=uk-breadcrumb>
  <li><a href="#!/">Home</a></li>
  <li><a href="#!/farms">Book a Visit</a></li>
  <li class=uk-active><span>{{farm.title}}</span></li>
</ul>
<div class=uk-grid data-uk-grid-margin>
  <div class=uk-width-1-1>
    <h2>{{ farm.title }}</h2>
    <p>Instructed by: {{ farm.expert.name }} </p>
  </div>
  <div class="uk-width-medium-1-2 uk-margin-top">
    <div class=uk-slidenav-position data-uk-slideshow="">
      <ul class=uk-slideshow style="">
        <li v-for="image in farm.images" track-by="$index">
          <img :src=image width="100%" height="50%" alt="">
        </li>
      </ul>
      <a href=# class="uk-slidenav uk-slidenav-contrast uk-slidenav-previous" data-uk-slideshow-item=previous style="color: rgba(255,255,255,0.4)"></a>
      <a href=# class="uk-slidenav uk-slidenav-contrast uk-slidenav-next" data-uk-slideshow-item=next style="color: rgba(255,255,255,0.4)"></a>
      <ul class="uk-dotnav uk-dotnav-contrast uk-position-bottom uk-flex-center">
        <li :data-Uk-Slideshow-Item=index v-for="index in farm.images.length">
          <a href=""></a>
        </li>
      </ul>
    </div>
  </div>

  <div class="uk-width-small-1-1 uk-width-medium-1-2">
    <div class="uk-panel">
      <div class="uk-grid uk-text-align" data-uk-grid-margin>
        <div class="uk-width-1-1">

        </div>
        <div class="uk-width-1-1">
          <div class="uk-align-right" style="font-size:1.5em; padding:10px; background-color: #AED47B; color: #ffffff">
            {{ farm.visitPrice }}
          </div>
          <h3>
            <i class="uk-icon uk-icon-clock-o"></i> Duration: <span class="uk-margin-left"> {{ farm.duration }} </span>  
          </h3>

          <h3> <i class="uk-icon uk-icon-map-marker"></i> Location: <span class="uk-margin-left"> {{ farm.location }} </span> </h3>
        </div>
        <div class=uk-width-1-1><a href=#payment-modal class="uk-button uk-button-large uk-button-primary uk-align-center" data-uk-modal><i class=uk-icon-card></i>Book Now</a></div>
      </div>
    </div>
  </div>

  <div class="uk-width-1-1">
    <ul class="uk-tab" data-uk-tab="connect:'#farm-tab'">
      <li class="uk-active"><a href="">Description</a></li>
      <li><a href="">Farm Expert</a></li>
    </ul>

    <ul id="farm-tab" class="uk-switcher uk-margin">
      <li>
        <dl class="uk-description-list-line">
          <dt><strong> Description </strong></dt>
          <dd> {{ farm.description }} </dd>
        </dl>
      </li>
      <li> {{ farm.expert.name }} </li>
    </ul>

  </div>


</div>

<div>
  <!--<iframe src="https://www.google.com/maps/embed/v1/place?q=Empire%20State%20Building
      &zoom=13
      &key=AIzaSyBKE4KdmbEeIyyCCSkP6I2I2rhW_xaL7q0">
  </iframe>-->
</div>

<div id=payment-modal class=uk-modal>
    <div v-show=!confirmed>
      <validator name="paymentvalidator" :groups="['paymentgroup']">
        <div class=uk-modal-dialog>
          <a class="uk-modal-close uk-close"></a>
          <ul>
            <li v-for="error in $paymentvalidator.errors">
              <p>{{error.field}}: {{error.message}}</p>
            </li>
          </ul>
          <h3><strong>Please confirm the details below</strong></h3>
          <div class="uk-accordion uk-margin-top" data-uk-accordion>
            
            <h3 class=uk-accordion-title>Select a date to visit<i class="uk-align-right uk-icon-small uk-icon-caret-down"></i></h3>            
            <div class=uk-accordion-content>
            <h3 class=uk-panel-title>Open <strong>Weekly</strong> on: <span class="uk-h5 uk-align-right">(Choose one of the days)</span></h3>
              <ul class="uk-list uk-list-striped">
                <li v-for="date in farm.dates"><label><input type=radio :name=day :value=date v-model="selectedDay"> {{ date.day }} <span class=uk-align-right>{{ date.start }} - {{ date.end }}</span></label>
                </li>
              </ul>
            </div>

            <h3 class=uk-accordion-title>Your Details<i class="uk-align-right uk-icon-small uk-icon-caret-down"></i></h3>
            <div class=uk-accordion-content>
              <form class=uk-form data-uk-margin>
                
                <div class=uk-form-row>
                  <label class=uk-form-label>Your Name</label>
                  <input 
                    v-model=user.name
                    class="uk-form-width-large "
                    placeholder="e.g. John Simba" 
                    v-validate:name="{ required: true, message: 'please put your name so that we can be friends :)' }" 
                    initial="off"
                    :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }"
                    group="paymentgroup" required>
                  
                </div>

                <div class=uk-form-row>
                  <label class=uk-form-label>Email Address</label>
                  <div class=uk-form-icon><i class=uk-icon-inbox></i> 
                  <input 
                    type=email 
                    v-model=user.email 
                    class=uk-form-width-large 
                    placeholder="e.g. you@youremail.com" 
                    v-validate:email="{ required: true, message: 'email requires an @ and a .', pattern: '/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i' }"
                    initial="off"
                    :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }"
                    group="paymentgroup" required>
                  </div>
                  
                </div>
                
                <div class=uk-form-row>
                  <label class=uk-form-label>Phone Number</label>
                  <div class="uk-form-icon uk-margin-small-top"><i class=uk-icon-phone></i>
                  <input 
                    type=tel 
                    v-model=user.phoneNumber 
                    class=uk-form-width-large 
                    placeholder="e.g. 0712123456"
                    v-validate:phonenumber="{ required: true, message: 'we will only use your number for good' }" 
                    initial="off"
                    :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }"
                    group="paymentgroup" required>
                    </div>
                    
                </div>
              </form>
            </div>

            <h3 class=uk-accordion-title>Farm Visit Summary<i class="uk-align-right uk-icon-small uk-icon-caret-down"></i></h3>
            
            <div class=uk-accordion-content>
              <div class=uk-grid data-uk-grid-margin>
                <div class=uk-width-1-10><i class="uk-icon-justify uk-icon-large uk-icon-map-marker"></i></div>
                <div class=uk-width-9-10>
                  <h3 class=uk-align-right>{{ farm.location }}</h3></div>
                <div class="uk-width-1-10 uk-margin-top"  v-show=selectedDay><i class="uk-icon-justify uk-icon-large uk-icon-clock-o"></i></div>
              <div class="uk-width-9-10 uk-margin-top"  v-show=selectedDay>
                <h3 class="uk-align-right ">{{ selectedDay.day }}, {{ selectedDay.start }} - {{ selectedDay.end }}</h3></div>
                <div class=uk-width-1-10><i class="uk-icon-justify uk-icon-large uk-icon-money"></i></div>
                <div class=uk-width-9-10>
                  <h3 class=uk-align-right>{{ farm.visitPrice }}</h3></div>
              </div>
            </div>
<!--      
            <h3 class=uk-accordion-title>How to Pay<i class="uk-align-right uk-icon-small uk-icon-caret-down"></i></h3>
            <div class=uk-accordion-content>
              <ol>
                <li>Go to the Safaricom MPESA Menu on your phone.</li>
                  <li>Click on Lipa na M-PESA</li>
                    <li>Click on Buy Goods and Services</li>
                      <li>Enter Till Number 888880</li>
                        <li>Enter amount Ksh. 2,000</li>
                          <li>Enter your PIN Number and click OK to complete the transaction. </li></ol>
            </div>-->
            <!--<h3 class=uk-accordion-title>Input Confirmation Code<i class="uk-align-right uk-icon-small uk-icon-caret-down"></i></h3>
            <div class=uk-accordion-content>
              <form class=uk-form>
                <div class=uk-form-row>
                  <label class=uk-form-label>M-PESA Confirmation Code</label>
                  <input 
                    class=uk-form-width-large 
                    v-model=confirmationCode 
                    placeholder="e.g. CHG84HXD8"
                    v-validate:confirm="{ required: true, message: 'please check your confirmation code' }" 
                    :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }"
                    group="paymentgroup">
                </div>
                
              </form>
            </div>-->
            <div class="uk-form-row uk-width-1-1">
                  <p></p>
                  <button 
                    class="uk-button uk-button-primary uk-button-large uk-align-center" 
                    type=button
                    v-if="$paymentvalidator.paymentgroup.valid" 
                    v-on:click="confirm">Book a Visit</button>
                </div>
          </div>
        </div>
      </validator>
    </div>

    <div v-if=confirmed>
      <div class=uk-modal-dialog>
        <a class="uk-modal-close uk-close"></a>
        <div class="uk-align-center uk-text-center">
          <h2>Thanks for your order</h2>
          <i style="color: #87AB61" class="fa fa-check-circle fa-5x"></i><br>
          <!--<a v-link="{name: 'farms'}" class="uk-margin-top"> Go back home</a>-->
          <h3>A Kuza representative will get back to you soon</h3>
          <h3>For inquiries call Isaac at</h3>
          <h2>+254718411704</h2>
          <h3>Or email</h3>
          <a href="mailto:farm@kuza.io"><h2>farm@kuza.io</h2></a>
        </div>
      </div>
    </div>
    
  </div>



</div>
</template>


<script>
  import store from '../store'
  var payload = { channel: "#orders", text: "" }

  export default {
    name: 'Farm',

    route: {
      
    },

    data() {
      return {
        farm: store.farm,
        selectedDay: "",
        user: {
          name: "",
          email: "",
          phoneNumber: ""
        },
        // confirmationCode: "",
        confirmed: false
      }
    },

    methods: {
      confirm: function() {
        console.log(this.confirmed)
        if (this.$paymentvalidator.paymentgroup.valid) {
          console.log(this.farmVisit)
          store.farmVisits.push(
            this.farmVisit
          )
          payload.text =  "Farm Visit Order\nname: " + this.user.name + 
                          "\nemail: " + this.user.email + 
                          "\nphone number: " + this.user.phoneNumber + 
                          "\nfarm: " + this.farm.title +
                          "\nselected Day: " + this.selectedDay.day

          $.post("https://hooks.slack.com/services/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", JSON.stringify(payload))
          this.confirmed = true    
        }
      },
      back: function() {
        this.$router.go('/')
      }
    },
    computed: {
      farmVisit() {
        return {
          user: {
            name: this.user.name,
            email: this.user.email,
            phoneNumber: this.user.phoneNumber
          },
          farm: {
            key: this.farm['.key'],
            slug: this.farm.slug,
            visitPrice: this.farm.visitPrice
          },
          selectedDay: {
            day: this.selectedDay.day,
            startTime: this.selectedDay.start,
            endTime: this.selectedDay.end
          }
          // confirmationCode: this.confirmationCode
        }
      }
    }


  }
</script>


/** WEBPACK FOOTER **
 ** Farm.vue?7744dcf4
 **/